import React from "react";

/**
 * Decorative footer — organic, hand-drawn-style mustard wave matching the reference.
 * Color: #CEC85C with a thick black top stroke.
 */
export const JaggedFooter = () => {
  return (
    <div className="relative w-full mt-16" data-testid="jagged-footer">
      <svg
        viewBox="0 0 1440 180"
        preserveAspectRatio="none"
        className="block w-full h-28 md:h-40"
        aria-hidden="true"
        style={{ filter: "drop-shadow(0 -8px 22px rgba(0,0,0,0.35))" }}
      >
        {/*
          Organic, irregular blob-style peaks (rounded humps of varying widths/heights)
          to mimic the hand-drawn reference. Curves use cubic Bezier (C/S commands).
        */}
        <path
          d="
            M 0 80
            C 50 30, 110 30, 160 80
            C 210 130, 260 110, 320 70
            C 380 30, 440 40, 500 90
            C 560 140, 620 100, 680 60
            C 740 20, 800 40, 860 100
            C 920 160, 980 120, 1040 80
            C 1100 40, 1160 50, 1220 100
            C 1280 150, 1340 110, 1400 70
            C 1420 56, 1432 50, 1440 50
            L 1440 180
            L 0 180
            Z
          "
          fill="#CEC85C"
          stroke="#000"
          strokeWidth="6"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
      <div className="bg-[#CEC85C] px-6 pb-6 pt-1 text-center font-body font-extrabold text-black text-xs md:text-sm tracking-widest uppercase">
        © {new Date().getFullYear()} Danyale &nbsp;·&nbsp; Made with retro love &nbsp;·&nbsp; All rights reserved
      </div>
    </div>
  );
};
